module.exports = __webpack_public_path__ + "img/13.d5ed24de.png";